<template>
  <v-card
    flat
    class="pa-3 mt-2"
  >
    <v-card-text>
      <v-form
        ref="form"
        class="multi-col-validation mt-6"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-select
              v-model="restaurantId"
              :items="restaurants"
              dense
              outlined
              clearable
              label="Заведение для расчёта корзины"
              hint="По нему считается корзина, пока гость своё заведение не выбрал"
              persistent-hint
            ></v-select>
          </v-col>

          <v-col cols="12">
            <v-alert
              text
              color="info"
              dense
            >
              Delivery без заведения корзину не считает вовсе, а гость выбирает его поздно:
              на доставке заведение называет зона адреса, на самовывозе — сам гость. До этого
              момента корзина считается по выбранному здесь. Цены и скидки у филиалов сходятся,
              поэтому подходит любое; когда гость выберет своё, витрина пересчитает по нему.
              Не выбрано — возьмём первое заведение с идентификатором Delivery.
            </v-alert>
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              class="me-3 mt-4"
              @click="saveData"
            >
              Сохранить
            </v-btn>
            <v-btn
              color="secondary"
              outlined
              class="mt-4"
              type="reset"
              @click="cancel"
            >
              Отмена
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mapFormHandlers } from '@/helpers/forms'

export default {
  name: 'CartCalculationSettingForm',
  computed: {
    ...mapFormHandlers('cartCalculationSettings', ['restaurantId']),
    ...mapGetters('restaurant', { restaurants: 'restaurantDropDown' }),
  },
  async created() {
    await this.fetch()
    await this.fetchRestaurants()
  },
  methods: {
    ...mapActions('cartCalculationSettings', ['update', 'fetch']),
    ...mapActions('restaurant', { fetchRestaurants: 'fetchDropDown' }),
    cancel() {
      this.$router.back()
    },
    async saveData() {
      await this.update()
    },
  },
}
</script>
